export default "__VITE_ASSET__jcPyBJ8X__"